import { useState } from 'react';
import TopBanner from '../acelera/components/TopBanner';
import HeroAcceleracao from './components/HeroAcceleracao';
import AuthoritySection from './components/AuthoritySection';
import PartnersSection from './components/PartnersSection';
import ClientsAcceleracao from './components/ClientsAcceleracao';
import MethodSection from './components/MethodSection';
import LeadFormModal from './components/LeadFormModal';
import Footer from '../../components/feature/Footer';
import ProcessoPrevisivelSection from './components/ProcessoPrevisivelSection';

function InlineLeadForm() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', company: '', revenue: '', challenge: '', goal: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      // Capturar UTMs da URL
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {
        utm_source: urlParams.get('utm_source') || '',
        utm_medium: urlParams.get('utm_medium') || '',
        utm_campaign: urlParams.get('utm_campaign') || '',
        utm_term: urlParams.get('utm_term') || '',
        utm_content: urlParams.get('utm_content') || ''
      };

      // Obter data e hora no fuso horário de São Paulo
      const now = new Date();
      const brasiliaTime = new Intl.DateTimeFormat('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(now);

      // Payload completo com dados do formulário + UTMs + data/hora
      const payload = {
        ...formData,
        ...utmParams,
        landing_page: 'aceleracao',
        data_hora_conversao: brasiliaTime
      };

      await fetch('https://webhooks.manager01.m4track.com.br/webhook/lp-2026-m4', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      setShowSuccessPopup(true);
    } catch (error) {
      console.error('Erro:', error);
    }
    setIsSubmitting(false);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    // Formatar campo WhatsApp
    if (name === 'phone') {
      const numbers = value.replace(/\D/g, '');
      let formatted = numbers;
      
      if (numbers.length <= 11) {
        if (numbers.length > 2) {
          formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
        }
        if (numbers.length > 7) {
          formatted = `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
        }
      }
      
      setFormData({ ...formData, [name]: formatted });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const closePopup = () => {
    setShowSuccessPopup(false);
    setFormData({ name: '', email: '', phone: '', company: '', revenue: '', challenge: '', goal: '' });
  };

  return (
    <>
      <section id="lead-form-section" className="py-16 lg:py-20 bg-gray-50">
        <div className="container px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-8 lg:mb-12">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 lg:mb-6 text-gray-900">
                Você pode estar <span className="text-orange-600">perdendo vendas todos os dias</span> sem perceber
              </h2>
              <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
                Receba um diagnóstico estratégico gratuito e descubra como estruturar marketing, atendimento e vendas em um único processo comercial.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 lg:p-12 shadow-2xl">
              <form onSubmit={handleSubmit} className="space-y-4 lg:space-y-6">
                <div className="grid md:grid-cols-2 gap-4 lg:gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Nome Completo *</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} required
                      className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                      placeholder="Seu nome completo" />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">E-mail *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required
                      className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                      placeholder="seu@email.com" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4 lg:gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">WhatsApp *</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required
                      className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                      placeholder="(11) 99999-9999" />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Empresa *</label>
                    <input type="text" name="company" value={formData.company} onChange={handleChange} required
                      className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                      placeholder="Nome da sua empresa" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Faturamento Mensal *</label>
                  <select name="revenue" value={formData.revenue} onChange={handleChange} required
                    className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm pr-8">
                    <option value="">Selecione o faturamento</option>
                    <option value="ate-10k">Até R$ 10.000</option>
                    <option value="10k-50k">R$ 10.000 - R$ 50.000</option>
                    <option value="50k-100k">R$ 50.000 - R$ 100.000</option>
                    <option value="100k-500k">R$ 100.000 - R$ 500.000</option>
                    <option value="500k-1m">R$ 500.000 - R$ 1.000.000</option>
                    <option value="acima-1m">Acima de R$ 1.000.000</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Principal Desafio *</label>
                  <select name="challenge" value={formData.challenge} onChange={handleChange} required
                    className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm pr-8">
                    <option value="">Selecione seu principal desafio</option>
                    <option value="gerar-leads">Gerar mais leads qualificados</option>
                    <option value="converter-vendas">Converter mais vendas</option>
                    <option value="automatizar-processos">Automatizar processos</option>
                    <option value="reduzir-cac">Reduzir custo de aquisição</option>
                    <option value="escalar-operacao">Escalar a operação</option>
                    <option value="melhorar-roi">Melhorar ROI do marketing</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Meta de Crescimento</label>
                  <textarea name="goal" value={formData.goal} onChange={handleChange} maxLength={500}
                    className="w-full px-3 lg:px-4 py-2.5 lg:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                    rows={4} placeholder="Descreva sua meta de crescimento para os próximos 6 meses..." />
                  <div className="text-right text-xs text-gray-500 mt-1">{formData.goal.length}/500 caracteres</div>
                </div>

                <div className="pt-2 lg:pt-4">
                  <button type="submit" disabled={isSubmitting}
                    className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 lg:px-8 py-3 lg:py-4 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-sm lg:text-base">
                    {isSubmitting ? <><i className="ri-loader-4-line mr-2 animate-spin"></i>Enviando Diagnóstico...</> : <><i className="ri-send-plane-line mr-2"></i>Receber Diagnóstico Gratuito</>}
                  </button>
                </div>

                <div className="text-center text-xs lg:text-sm text-gray-600">
                  <i className="ri-shield-check-line text-green-500 mr-1"></i>
                  Seus dados estão seguros e não serão compartilhados
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 text-center relative">
            <button onClick={closePopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl cursor-pointer">
              <i className="ri-close-line"></i>
            </button>
            <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Informações Recebidas!</h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Recebemos suas informações com sucesso! Acabamos de enviar uma mensagem no seu WhatsApp com os próximos passos.
            </p>
            <div className="space-y-3">
              <button onClick={closePopup} className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-300 cursor-pointer">
                <i className="ri-whatsapp-line mr-2"></i>Verificar WhatsApp
              </button>
              <button onClick={closePopup} className="w-full border-2 border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors cursor-pointer">
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function AceleracaoPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form-section');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen">
      <TopBanner />
      <HeroAcceleracao onOpenModal={scrollToForm} />
      <InlineLeadForm />
      <ProcessoPrevisivelSection />
      <AuthoritySection />
      <ClientsAcceleracao />
      <PartnersSection />
      <MethodSection onOpenModal={scrollToForm} />
      <Footer onOpenModal={scrollToForm} />

      {/* Modal de Formulário */}
      <LeadFormModal isOpen={isModalOpen} onClose={closeModal} landingPage="aceleracao" />
    </div>
  );
}
